<template>
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="row">
          <div class="col-5">
            <div class="element-wrapper">
              <h6 class="element-header">{{ t('importDataFileHeader', 'importDataFileHeader')}}</h6>
              <div class="element-box">
                <div class="row">
                  <ResponseInfo v-if="getResponseInfo.responseName == 'importDataFile'" class="mb-3" />
                </div>
                <div class="row text-center form-line form-group" v-if="availableBatchTypes" style="margin: 0px 0px 15px 0px;">
                  <div class="col-4">{{ t('importDataSelectBatchLabel', 'importDataSelectBatchLabel') }}</div>
                  <div class="col-8">
                    <b-form-select v-model="selectedBatchType" @change="selectBatch($event)">
                      <option v-for="batchType in availableBatchTypes" :key="batchType.id" :value="batchType.id">{{ batchType.name }}</option>
                    </b-form-select>
                  </div>
                </div>
                <div class="col-12 form-group">
                  <div v-if="selectedBatchType" class="element-info">
                    <form v-on:submit.prevent="importDataFile">
                      <div class="col-12" v-if="getUserDetails.is_tester" style="padding: 0px;">
                        <div class="row form-group form-line">
                          <div class="col-6">{{ t('importDataIsTestBatchLabel', 'importDataIsTestBatchLabel') }}</div>
                          <div class="col-6">
                            <b-form-checkbox v-model="importParams.isTestBatch"></b-form-checkbox>
                          </div>
                        </div>
                        <div class="row form-group form-line">
                          <div class="col-6">{{ t('importDataSimulateDeliveriesLabel', 'importDataSimulateDeliveriesLabel') }}</div>
                          <div class="col-6">
                            <b-form-radio value="simulate_deliveries" v-model="importParams.deliveryMode"></b-form-radio>
                          </div>
                        </div>
                        <div class="row form-group form-line">
                          <div class="col-6">{{ t('importDataDiverDeliveriesToTesterLabel', 'importDataDiverDeliveriesToTesterLabel') }}</div>
                          <div class="col-6">
                            <b-form-radio value="divert_deliveries" v-model="importParams.deliveryMode"></b-form-radio>
                          </div>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-4">{{ t('importDataFileToUploadLabel', 'importDataFileToUploadLabel') }}</div>
                        <div class="col-8">
                          <b-form-file id="importedFile" v-model="importedFile"></b-form-file>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-4">{{ t('importDataFileReferenceLabel', 'importDataFileReferenceLabel') }}</div>
                        <div class="col-8">
                          <input class="form-control" id="fileReference" name="fileReference" v-model="importParams.reference" :placeholder="'Reference'" type="text">
                        </div>
                        <div class="col-4"></div>
                        <div class="col-8">{{ t('importDataFileReferenceDesc', 'importDataFileReferenceDesc') }}</div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-6">
                          {{ t('importDataCreateNonExistingCustomers', 'importDataCreateNonExistingCustomers') }}
                        </div>
                        <div class="col-6 text-left">
                          <b-form-checkbox v-model="importParams.createCustomers"></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-6">
                          {{ t('importDataUpdateCustFromDataLabel', 'importDataUpdateCustFromDataLabel') }}
                        </div>
                        <div class="col-6 text-left">
                          <b-form-checkbox v-model="importParams.updateCustDetails"></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-6">
                          {{ t('importDataUpdateCustDeliveryDataLabel', 'importDataUpdateCustDeliveryDataLabel') }}
                        </div>
                        <div class="col-6 text-left">
                          <b-form-checkbox v-model="importParams.updateCustDeliveryDetails"></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-6">
                          {{ t('importDataUpdateCustDeliveryPreferenceLabel', 'importDataUpdateCustDeliveryPreferenceLabel') }}
                        </div>
                        <div class="col-6 text-left">
                          <b-form-checkbox v-model="importParams.updateCustDeliveryPreferences"></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-6">
                          {{ t('importDataSendProofRemindersLabel', 'importDataSendProofRemindersLabel') }}
                        </div>
                        <div class="col-6 text-left">
                          <b-form-checkbox v-model="importParams.sendProofReminders"></b-form-checkbox>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-4">
                          {{ t('importDataLookForDeliveryDataLabel', 'importDataLookForDeliveryDataLabel') }}
                        </div>
                        <div class="col-8">
                          <b-form-select v-model="importParams.firstDataSearch">
                            <option value="data">{{ t('importDataLookForDocDataOption', 'importDataLookForDocDataOption') }}</option>
                            <option value="customer">{{ t('importDataLookForCustRecordOption', 'importDataLookForCustRecordOption') }}</option>
                          </b-form-select>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-4">
                          {{ t('importDataThenLookInLabel', 'importDataThenLookInLabel') }}
                        </div>
                        <div class="col-8">
                          <b-form-select v-model="importParams.nextDataSearch">
                            <option value="">{{ t('importDataLookForNowhereOption', 'importDataLookForNowhereOption') }}</option>
                            <option value="data">{{ t('importDataLookForDocDataOption', 'importDataLookForDocDataOption') }}</option>
                            <option value="customer">{{ t('importDataLookForCustRecordOption', 'importDataLookForCustRecordOption') }}</option>
                          </b-form-select>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-4">
                          {{ t('importDataNotifyWhenProofReadyLabel', 'importDataNotifyWhenProofReadyLabel') }}
                        </div>
                        <div class="col-8">
                          <input class="form-control" id="notifyEmail" name="notifyEmail" v-model="importParams.notifyEmail" :placeholder="'Notify email'" type="text" required>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-4">
                          {{ t('importDataOverrideDocDatesLabel', 'importDataOverrideDocDatesLabel') }}
                        </div>
                        <div class="col-8">
                          <datePicker id="overrideDocumentReferences" v-model="importParams.overrideDocumentDates" class="form-control" :config="overrideConfig"></datePicker>
                        </div>
                      </div>
                      <div class="row form-group form-line">
                        <div class="col-4">
                          {{ t('importDataOverrideDocReferencesLabel', 'importDataOverrideDocReferencesLabel') }}
                        </div>
                        <div class="col-8">
                          <input class="form-control" id="overrideDocumentReferences" name="overrideDocumentReferences" v-model="importParams.overrideDocumentReferences" type="text">
                        </div>
                      </div>
                      <div v-if="importedFile && importedFile != '' && selectedBatchType && selectedBatchType != ''" class="form-buttons-w text-right">
                        <button class="btn btn-primary" type="submit" value="submit" :disabled="isUploading">{{ t('importDataUploadButtonText', 'importDataUploadButtonText') }}</button>
                      </div>
                    </form>
                  </div>
                  <div v-else class="element-info">
                    {{ t('importDataSelectBatchTypeToContinueText', 'importDataSelectBatchTypeToContinueText') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo'
import datePicker from 'vue-bootstrap-datetimepicker'
import { mapGetters } from 'vuex'
import moment from 'moment'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
  name: 'ImportDataFile',
  components: {

  },
  data () {
    return {
      selectedBatchType: '',
      importedFile: null,
      importParams: {
        isTestBatch: false,
        deliveryMode: 'simulate_deliveries',
        reference: '',
        createCustomers: false,
        updateCustDetails: false,
        updateCustDeliveryDetails: false,
        updateCustDeliveryPreferences: false,
        sendProofReminders: false,
        firstDataSearch: 'data',
        nextDataSearch: '',
        notifyEmail: '',
        overrideDocumentDates: '',
        overrideDocumentReferences: ''
      },
      overrideConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        //format: 'DD/MM/YYYY'
        format: this.datePickerFormat,
        maxDate: moment(new Date(), this.datePickerFormat),
        showClear: true
      },
      initialData: {},
      isUploading: false
    }
  },
  components: {
    ResponseInfo,
    datePicker
  },
  methods: {
    importDataFile() {
      let formData = new FormData();

      formData.append('importedFile', this.importedFile)
      formData.append('batchTypeId', this.selectedBatchType)
      formData.append('sessionToken', this.$store.getters.getUserSessionToken)

      for(let key in this.importParams) {
        formData.append(key, this.importParams[key])
      }

      if(this.selectedBatchType && this.importedFile) {
        this.isUploading = true
        this.$store.dispatch('importDataFileStore/importDataFile', formData).then(() => {
          this.selectedBatchType = ''
          this.importedFile = ''
          // NS-10017 Unlock button after the import, PW
          this.isUploading = false
          this.importParams = { ...this.initialData.importParams }
        })
      }
    },
    selectBatch(event) {
      this.$router.push({ query: { batchType: event } })
      this.getImportFormDefaultValues()
    },
    getSelectableBatchTypes() {
      this.$store.dispatch('importDataFileStore/getImportBatchTypes')
    },
    getImportFormDefaultValues() {
      if(this.selectedBatchType) {
        this.$store.dispatch('importDataFileStore/getImportFormDefaultValues', {
          batchTypeId: this.selectedBatchType,
          sessionToken: this.$store.getters.getUserSessionToken
        }).then(response => {
          let defaults = this.getFormDefaults
          this.importParams = { ...this.importParams, ...defaults }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['getOnlineUsers', 'getUserDetails', 'getUserLevel', 'getResponseInfo']),
    ...mapGetters('importDataFileStore', ['getBatchTypes', 'getFormDefaults']),
    datePickerFormat() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
        return dateformat
      } else {
        return "DD-MM-YYYY"
      }
    },
    availableBatchTypes: {
      get() {
        return this.getBatchTypes
      }
    }
  },
  created() {
    this.overrideConfig.format = this.datePickerFormat

    this.getSelectableBatchTypes()

    if(this.$route.query.batchType) {
      this.selectedBatchType = this.$route.query.batchType
    }

    this.initialData = this.$data

    this.getImportFormDefaultValues()
  }
}

</script>

<style scoped>
  .element-box {
    margin-bottom: 0px;
    padding-bottom: 10px;
  }
  .element-info {
    border-bottom: none;
    margin-bottom: 0px;
    padding-top: 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
  .form-line {
    display: flex;
    align-items: center;
  }
</style>
